class DoctorRecommended extends HTMLElement {
  constructor() {
    super();
    this.searchClient = algoliasearch.algoliasearch('P0Z7SW5ST1', '6ae1c924d6fbc5a4087e7310781f29b1');
    this.storefrontToken = '314d12ac67dc94414f1a58cf9a7b1d93';
    this.storefrontEndpoint = 'https://287197-d4.myshopify.com/api/2024-01/graphql.json';
    this.collectionHandle = 'products';
    this.doctorName = this.querySelector('.container-header__doctor-name');
    this.customerName = this.querySelector('.container-header__customer-name');
    this.productsCount = this.querySelector('.container-header__products-count');
    this.checkoutButtonsContainer = document.querySelector('.checkout-buttons__container');
    this.loadingProductsContainer = document.querySelector('.products-container__loading-products');
    this.clinicName = document.querySelector('.doctor-recommended__header-clinic-name');
    this.clinicHeader = document.querySelector('.doctor-recommended__header');
    this.doctorRecommendedHeader = this.querySelector('.doctor-recommended__container-header');
    const urlParams = new URLSearchParams(window.location.search);
    this.uniqUrlKey = urlParams.get('id');
    window.addEventListener('resize', this.updatePaddingBottom);
    this.updatePaddingBottom();
    this.modalOpen = false;
    this.modalContainer = null;
    document.addEventListener('keydown', this.handleEscKey.bind(this));
  }

  async connectedCallback() {
    await this.getDoctorByObjectID();
  }
  
  updatePaddingBottom() {
    const checkoutWrapper = document.querySelector('.checkout-buttons__wrapper');
    const wrapperHeight = checkoutWrapper ? checkoutWrapper.offsetHeight : 0;
    if (window.innerWidth < 768) {
      document.body.style.paddingBottom = `${wrapperHeight - 10}px`;
    } else if (window.innerWidth < 1150) {
      document.body.style.paddingBottom = `${wrapperHeight - 60}px`;
    } else {
      document.body.style.paddingBottom = '';
    }
  }

  refactorAdditionalCheckoutButtons() {
    const walletElemAttr = document.getElementById('wallet')?.innerText;
    const walletElem = walletElemAttr?.split('wallet-configs="')[1]?.split('"')[0];
    const walletElemClear = walletElem?.replace(/&quot;/g, '"');
    const jsonWallet = JSON.parse(walletElemClear);

    let filteredWallet = jsonWallet?.filter((item) => item.name === 'apple_pay');

    if (!filteredWallet.length) {
        filteredWallet = jsonWallet?.filter((item) => item.name === 'shop_pay');
    }

    const newWalletStr = JSON.stringify(filteredWallet)?.replaceAll('"', '&quot;');
    const newWallStr = document.getElementById('wallet')?.innerText?.replace(walletElem, newWalletStr);

    document.getElementById('wallet')?.insertAdjacentHTML('beforebegin', newWallStr);
  }

  async getDoctorByObjectID(query = '') {
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      const { results } = await this.searchClient.search([
        {
          indexName: 'PROD_PRN_LEADS',
          filters: `uniqUrlKey:${this.uniqUrlKey}`,
          query
        }
      ]);
  
      if (!results?.length || !results[0]?.hits?.length) {
        return;
      }
  
      const doctorData = results[0].hits[0];
      this.doctorInfo = doctorData?.doctorInfo?.[0];
      this.doctorObjectID = doctorData.objectID;
      const productSKUs = (doctorData.products || []).map(sku => (sku ? sku.trim() : ''));
      const addressParts = [this.doctorInfo.parent, this.doctorInfo.address?.city, this.doctorInfo.address?.line_1, this.doctorInfo.address?.region, this.doctorInfo.address?.postalCode, this.doctorInfo.address?.country].filter(Boolean);
      const addressString = addressParts.join(', ');
      this.LeadID = doctorData?.objectID;
      localStorage.setItem('selectedDoctor', JSON.stringify({
        name: this.doctorInfo?.name?.split(':')[1].trim(),
        address: addressString,
        id: doctorData.objectID,
        indexName: 'PROD_PRN_DOC',
        objectData: this.doctorInfo,
      }));

      localStorage.setItem('visitDoctorRecommendationPage', 'true');

      if (!this.doctorInfo || !this.doctorInfo.name) {
        return;
      }
      this.customerName.innerHTML = doctorData.name.split(' ')[0].trim();
      this.clinicName.innerHTML = this.doctorInfo.name.split(':')[0].trim();
      this.doctorName.innerHTML = `Dr ${doctorData.doctorName.trim()}`;

      if (!productSKUs.length) {
        return;
      }
      
      const collectionProducts = await this.getCollectionProducts(this.collectionHandle);
      if (!Array.isArray(collectionProducts) || !collectionProducts.length) {
        return;
      }
      this.matchedProducts = collectionProducts.filter(product =>
        product.variants?.some(variant => 
          productSKUs.some(sku => variant.sku.includes(sku))
        )
      );
  
      if (!this.matchedProducts.length) {
        return;
      }
  
      this.cartItems = this.matchedProducts.flatMap(product => {
        const relevantVariants = product.variants?.filter(variant => variant.showForDoctorsRecommended?.value === "true" && variant.sku.includes('Recommended'));
        const productSKUCount = product.variants.filter(variant => productSKUs.includes(variant.sku)).length;
      
        const selectedVariants = productSKUCount >= 2 ? relevantVariants.slice(0, 2) : relevantVariants.slice(0, 1);
      
        return selectedVariants.map(variant => {
          const variantId = variant?.id?.replace('gid://shopify/ProductVariant/', "");
          const sellingPlanId = variant?.sellingPlanAllocations?.nodes?.[0]?.sellingPlan?.id?.replace('gid://shopify/SellingPlan/', "");
      
          return variantId ? { id: variantId, quantity: 1, selling_plan: sellingPlanId || null } : null;
        });
      }).filter(item => item !== null);
    
      if (!this.cartItems.length) {
        return;
      }

      this.productsCount.innerHTML = this.cartItems.length;
  
      const currentCart = await this.getCartItems();

      
      const newItemsToAdd = this.cartItems.filter(item =>
        !currentCart.some(cartItem => cartItem.id == item.id)
      );
  
      if (newItemsToAdd.length) {
        await this.addToCart(newItemsToAdd);
      } else if (!currentCart.length) {
        await this.addToCart(this.cartItems);
      }
      this.loadingProductsContainer.style.display = 'none'
      this.clinicHeader.style.display = 'block'
      this.doctorRecommendedHeader.style.display = 'block'
      this.renderProducts(this.matchedProducts, productSKUs);
      this.checkoutButtonsContainer.style.display = 'block'
      this.updatePaddingBottom();
      
      // Add a delay to ensure cart is updated before updating product quantity states
      setTimeout(async () => {
        this.refactorAdditionalCheckoutButtons();
        
        // Get the latest cart data after adding products
        const updatedCart = await this.getCartItems();
        // Initialize product states with updated cart data
        this.initializeProductStates(updatedCart);
      }, 2000);

    } catch (err) {
      console.error('Error fetching doctor:', err);
    }
  }
  

  async addToCart(items) {
    try {
      const doctorInfoToString = JSON.stringify(this.doctorInfo);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items,
          attributes: {
            'referral': doctorInfoToString,
            'doc_reco': true,
            'objectID': this.doctorInfo.objectID,
            'Lead ID': this.LeadID
          }
        })
      });
  
      const data = await response.json();
      
      // Return the updated cart data
      return data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      return null;
    }
  }

  async getCartItems() {
    try {
      const response = await fetch('/cart.js');
      const data = await response.json();
      return data.items || [];
    } catch (error) {
      console.error('Error fetching cart items:', error);
      return [];
    }
  }
  


  productCardComponent(variant, productTitle) {
    const sellingPlan = variant.sellingPlanAllocations?.nodes?.[0]?.sellingPlan;
    const subscriptionPrice = variant.sellingPlanAllocations?.nodes?.[0]?.priceAdjustments?.[0]?.price;
    const percentageValue = sellingPlan?.priceAdjustments?.[0]?.adjustmentValue?.adjustmentPercentage;

    const variantPrice = sellingPlan ? subscriptionPrice.amount : variant.priceV2.amount;
    const cleanTitle = variant.title.replace(/\s*\(Recommended\)/, '');
    const selectedOptions = variant.selectedOptions.map(option => 
        `<div class="option-name">
          ${option.name}: <span class="option-value">${option.value.replace(/\s*\(Recommended\)/, '')}</span>
        </div>`
    ).join('');

    return `
      <recommended-product id="${variant.id}" class="recommended-card__container" data-handle="${variant.product.handle}">
        <div class="recommended-card__info-container">
          <div class="recommended-card__image recommended-card__image-desktop product-modal-trigger" data-handle="${variant.product.handle}">
            <img width="324" src="${variant.image?.src || ''}" alt="${cleanTitle}" />
          </div>
          <div class="recommended-card__info">
            <div class="recommended-card__info-wrapper">
              <div class="recommended-card__image recommended-card__image-mobile product-modal-trigger" data-handle="${variant.product.handle}">
                <img width="114" src="${variant.image?.src || ''}" alt="${cleanTitle}" />
              </div>
              <div class="card__info__content">
                <h3 class="card__info-title product-modal-trigger" data-handle="${variant.product.handle}">${productTitle}</h3>
                <div class="card__info-rating" data-handle="${variant.product.handle}"></div>
                <div class="card__info-options-container">
                  <div class="card__info-options">
                    ${selectedOptions}
                  </div>
                  ${variant?.retailPrice?.value ? `
                    <div class="card__info-price">
                      <span class="card__info-price-text">Retail Price:</span>
                      <span class="card__info-price-container">
                        ${
                          window.Shopify.formatMoney(
                            parseFloat(variant.retailPrice.value).toFixed(2),
                            window.theme.money_format,
                          )
                        }
                      </span>
                    </div>
                  `: ''}
                </div>
              </div>
            </div>
            <div class="recommended-card__info-subscription-container">
              ${sellingPlan ? `
                <div class="recommended-card__subscription-container">
                  <label class="recommended-card__option">
                    <input type="radio" hidden name="purchase-option-${variant.id}" value="${sellingPlan.id}" data-plan-id="${sellingPlan.id}" checked />
                    <div class="info-container">
                      <div class="info-container__circle"></div>
                      <div class="subscription-info-content">
                        <div class="subscription__label">
                          <span>Subscribe & Save ${percentageValue}%</span>
                          ${variant?.subscriptionSubText?.value ? `
                            <span class="subscription__label-sub-text">${variant?.subscriptionSubText?.value}</span>
                          `: ''}
                        </div>
                        <div class="subscription__price">
                          <span class="subscription__price-name">Your Price:</span>
                          <span class="subscription__price-content">
                            ${
                              window.Shopify.formatMoney(
                                subscriptionPrice.amount * 100,
                                window.theme.money_format,
                              )
                            }<span class="subscription__price-ea">ea</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              ` : ''}
              ${variant?.showOTP?.value == 'true' ? `
                <div class="recommended-card__one-time-container">
                  <label class="recommended-card__option">
                    <input type="radio" hidden name="purchase-option-${variant.id}" value="" ${!sellingPlan ? 'checked' : ''} />
                    <div class="info-container">
                      <div class="info-container__circle"></div>
                      <div class="subscription-info-content">
                        <div class="subscription__label">
                          One-Time Purchase
                        </div>
                        <div class="subscription__price">
                          <span class="subscription__price-name">Your Price:</span>
                          <span class="subscription__price-content">
                            ${
                              window.Shopify.formatMoney(
                                variant.priceV2.amount * 100,
                                window.theme.money_format,
                              )
                            }<span class="subscription__price-ea">ea</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              ` : ''}
            </div>
          </div>
        </div>
      </recommended-product>
    `;
  }


  
  renderProducts(products, productSKUs) {
    const container = this.querySelector('.doctor-recommended__products-container');
    if (!container) return;
  
    const skuCounts = productSKUs.reduce((acc, sku) => {
      acc[sku] = (acc[sku] || 0) + 1;
      return acc;
    }, {});

    const matchedVariants = products.flatMap(product => {
      const relevantVariants = product.variants.filter(variant => variant.showForDoctorsRecommended?.value === "true" && variant.sku.includes('Recommended'));
      const productSKUCount = product.variants.filter(variant => productSKUs.includes(variant.sku)).length;
  
      return productSKUCount >= 2 ? relevantVariants.slice(0, 2) : relevantVariants.slice(0, 1);
    });
  
    container.innerHTML = matchedVariants.map(variant => {
      return this.productCardComponent(variant, variant.product.title);
    }).join('');

    this.initializeProductStates();
    this.loadInlineRatings(matchedVariants);
  }

  async loadInlineRatings(matchedVariants) {
    // Get unique product handles from the rendered variants
    const handles = [...new Set(matchedVariants.map(v => v.product.handle))];

    await Promise.all(
      handles.map(async (handle) => {
        try {
          // Use the same section as the More Info modal:
          // /products/{handle}?section_id=main-product-modal
          const response = await fetch(`/products/${handle}?section_id=main-product-modal`);
          if (!response.ok) {
            console.warn('Section render failed for handle:', handle, 'status:', response.status);
            return;
          }

          const html = await response.text();
          const temp = document.createElement('div');
          temp.innerHTML = html;

          // Try multiple Bazaarvoice selectors – adjust if BV markup changes
          const ratingEl =
            temp.querySelector('.bv_ratings_summary') ||
            temp.querySelector('[data-bv-show="rating_summary"]') ||
            temp.querySelector('[data-bv-show="inline_rating"]') ||
            temp.querySelector('.bv_main_container');

          if (!ratingEl) {
            console.warn('No BV rating element found for handle:', handle);
            return;
          }

          const ratingHTML = ratingEl.outerHTML;

          // Inject rating snippet into each DRLP card for this handle
          const ratingTargets = this.querySelectorAll(
            `.card__info-rating[data-handle="${handle}"]`
          );

          ratingTargets.forEach((target) => {
            target.innerHTML = ratingHTML;
          });

        } catch (err) {
          console.error(`Error loading ratings for ${handle}`, err);
        }
      })
    );

    // Optional: refresh Bazaarvoice so the newly injected HTML hydrates
    if (window.BV && typeof window.BV.reviewsOnPageRefresh === 'function') {
      try {
        window.BV.reviewsOnPageRefresh();
      } catch (e) {
        console.warn('BV refresh failed:', e);
      }
    }
  }


  async initializeProductStates(cartData = null) {
    // If cart data is not provided, fetch it
    if (!cartData) {
      cartData = await this.getCartItems();
    }
    
    // Wait for DOM to be ready
    setTimeout(() => {
      const productCards = document.querySelectorAll('recommended-product');
      productCards.forEach(card => {
        card.initializeWithCartData(cartData);
      });
    }, 300);
  }
  

  handleEscKey(event) {
    if (event.key === 'Escape' && this.modalOpen) {
      this.closeProductModal();
    }
  }

  createModalContainer() {
    // Create modal overlay container if it doesn't exist
    if (!document.getElementById('product-modal-overlay')) {
      const modalOverlay = document.createElement('div');
      modalOverlay.id = 'product-modal-overlay';
      modalOverlay.className = 'product-modal-overlay';
      modalOverlay.style.display = 'none';
      
      const modalContainer = document.createElement('div');
      modalContainer.id = 'product-modal-container';
      modalContainer.className = 'product-modal-container';
      
      const modalContent = document.createElement('div');
      modalContent.id = 'product-modal-content';
      modalContent.className = 'product-modal-content';
      
      const closeButton = document.createElement('button');
      closeButton.className = 'product-modal-close';
      closeButton.setAttribute('aria-label', 'Close modal');
      closeButton.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      `;
      closeButton.addEventListener('click', this.closeProductModal.bind(this));
      
      const loadingSpinner = document.createElement('div');
      loadingSpinner.className = 'product-modal-loading';
      loadingSpinner.innerHTML = `
        <div class="loading-spinner">
          <div class="spinner-circle"></div>
        </div>
      `;
      
      modalContent.appendChild(closeButton);
      modalContent.appendChild(loadingSpinner);
      modalContainer.appendChild(modalContent);
      modalOverlay.appendChild(modalContainer);
      
      document.body.appendChild(modalOverlay);
      
      // Close modal when clicking on overlay outside the modal
      modalOverlay.addEventListener('click', (event) => {
        if (event.target === modalContainer || event.target === modalOverlay) {
          this.closeProductModal();
        }
      });
      
      this.modalContainer = modalOverlay;
    }
    
    return document.getElementById('product-modal-overlay');
  }

  async openProductModal(productHandle) {
    // Create modal if it doesn't exist yet
    const modalOverlay = this.createModalContainer();
    const modalContent = modalOverlay.querySelector('#product-modal-content');
    const loadingSpinner = modalOverlay.querySelector('.product-modal-loading');
    
    // Show loading spinner and modal
    loadingSpinner.style.display = 'flex';
    modalOverlay.style.display = 'block';
    
    // Prevent body scrolling
    
    this.scrollPosition = window.scrollY;

    document.documentElement.style.overflow = 'hidden';
    
    this.modalOpen = true;
    
    try {
      // Clear previous content
      const existingProductContent = modalContent.querySelector('.product-modal-loaded-content');
      if (existingProductContent) {
        existingProductContent.remove();
      }
      
      // Load product details using Section Render API
      const response = await fetch(`/products/${productHandle}?section_id=main-product-modal`);
      
      if (!response.ok) {
        throw new Error('Failed to load product details');
      }
      
      const html = await response.text();
      
      // Create a container for the loaded content
      const loadedContentContainer = document.createElement('div');
      loadedContentContainer.className = 'product-modal-loaded-content';
      this._observeRatingsSummary();
      
      // Insert the HTML directly - it should already contain the formatted product section
      loadedContentContainer.innerHTML = html;
      
      // Remove unnecessary elements that might be included in the section render
      const elementsToRemove = [ 
        '.breadcrumbs', 
        '.product-single__box__block--variant_picker',
        '.product-single__box__block--quantity_selector',
        '.product-single__box__block--buy_buttons',
        '.shopify-payment-button',
        '.shopify-section-header-sticky',
        '.announcement-bar',
        '.header__inline-menu',
        '.header__icons'
      ];
      
      elementsToRemove.forEach(selector => {
        const elements = loadedContentContainer.querySelectorAll(selector);
        elements.forEach(el => el.parentNode?.removeChild(el));
      });
      
      modalContent.appendChild(loadedContentContainer);
      
      setTimeout(() => {
        // Run theme's animation function if available
        if (typeof theme !== 'undefined' && typeof theme.animScroll === 'function') {
          theme.animScroll();
        }
        
        // Get slider elements
        const productImageSliderPDP = loadedContentContainer.querySelector('.product-image-slider-pdp');
        const productThumbnailSliderPDP = loadedContentContainer.querySelector('.product-thumbnail-slider-pdp');
        
        // Initialize main product slider
        if (productImageSliderPDP) {
          const prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15.5306 18.9698C15.6003 19.0395 15.6556 19.1222 15.6933 19.2132C15.731 19.3043 15.7504 19.4019 15.7504 19.5004C15.7504 19.599 15.731 19.6965 15.6933 19.7876C15.6556 19.8786 15.6003 19.9614 15.5306 20.031C15.461 20.1007 15.3782 20.156 15.2872 20.1937C15.1961 20.2314 15.0986 20.2508 15 20.2508C14.9015 20.2508 14.8039 20.2314 14.7128 20.1937C14.6218 20.156 14.5391 20.1007 14.4694 20.031L6.96938 12.531C6.89965 12.4614 6.84433 12.3787 6.80659 12.2876C6.76885 12.1966 6.74942 12.099 6.74942 12.0004C6.74942 11.9019 6.76885 11.8043 6.80659 11.7132C6.84433 11.6222 6.89965 11.5394 6.96938 11.4698L14.4694 3.96979C14.6101 3.82906 14.801 3.75 15 3.75C15.199 3.75 15.3899 3.82906 15.5306 3.96979C15.6714 4.11052 15.7504 4.30139 15.7504 4.50042C15.7504 4.69944 15.6714 4.89031 15.5306 5.03104L8.56032 12.0004L15.5306 18.9698Z" fill="black"/>
              </svg></button>`,
              nextArrow = `<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M17.0307 12.531L9.53068 20.031C9.46099 20.1007 9.37827 20.156 9.28722 20.1937C9.19618 20.2314 9.0986 20.2508 9.00005 20.2508C8.9015 20.2508 8.80392 20.2314 8.71288 20.1937C8.62183 20.156 8.53911 20.1007 8.46943 20.031C8.39974 19.9614 8.34447 19.8786 8.30676 19.7876C8.26904 19.6965 8.24963 19.599 8.24963 19.5004C8.24963 19.4019 8.26904 19.3043 8.30676 19.2132C8.34447 19.1222 8.39974 19.0395 8.46943 18.9698L15.4397 12.0004L8.46943 5.03104C8.32869 4.89031 8.24963 4.69944 8.24963 4.50042C8.24963 4.30139 8.32869 4.11052 8.46943 3.96979C8.61016 3.82906 8.80103 3.75 9.00005 3.75C9.19907 3.75 9.38995 3.82906 9.53068 3.96979L17.0307 11.4698C17.1004 11.5394 17.1557 11.6222 17.1935 11.7132C17.2312 11.8043 17.2506 11.9019 17.2506 12.0004C17.2506 12.099 17.2312 12.1966 17.1935 12.2876C17.1557 12.3787 17.1004 12.4614 17.0307 12.531Z" fill="black"/>
              </svg></button>`;

          if (typeof jQuery === 'function' && typeof jQuery().slick === 'function') {
            // Fallback to slick slider if Swiper is not available
            jQuery(productImageSliderPDP).slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              prevArrow:
              '<button type="button" class="media-gallery__arrow media-gallery__arrow--prev"><i class="icon icon--left"></i></button>',
              nextArrow:
              '<button type="button" class="media-gallery__arrow media-gallery__arrow--next"><i class="icon icon--right"></i></button>',
              fade: true,
              infinite: false,
              asNavFor: productThumbnailSliderPDP ? '.product-thumbnail-slider-pdp' : null
            });
            
            if (productThumbnailSliderPDP) {
              jQuery(productThumbnailSliderPDP).slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.product-image-slider-pdp',
                dots: false,
                centerMode: false,
                focusOnSelect: true,
                arrows: false,
                prevArrow,
                nextArrow,
                infinite: false,
                swipe: false,
                centerPadding: 0,
                responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                    centerMode: false,
                  }
                }]
              });
            }
          }
        }
        
        // Initialize any other custom sliders
        const customSliders = loadedContentContainer.querySelectorAll('[data-slider]:not(.product-image-slider-pdp):not(.product-thumbnail-slider-pdp)');
        if (customSliders.length && typeof window.initializeCustomSliders === 'function') {
          window.initializeCustomSliders(customSliders);
        }

        // Send GA4 event for opening the modal
        this.sendGA4Event('drlp-more-info', { product_handle: productHandle });

        loadingSpinner.style.display = 'none';
        loadedContentContainer.classList.add('modal-content-loaded');
      }, 500);
      
    } catch (error) {
      console.error('Error loading product details:', error);
      loadingSpinner.style.display = 'none';
      
      // Show error message
      const errorMessage = document.createElement('div');
      errorMessage.className = 'product-modal-error';
      errorMessage.textContent = 'Failed to load product details. Please try again.';
      modalContent.appendChild(errorMessage);
    }
  }

  closeProductModal() {
    if (!this.modalContainer) return;
    
    // Send GA4 event for dismissing the modal
    this.sendGA4Event('drlp-more-info-dismiss');
    
    // Hide modal
    this.modalContainer.style.display = 'none';
    
    document.documentElement.style.overflow = '';
    this.modalOpen = false;
  }

  // Helper function to send GA4 events
  sendGA4Event(eventName, eventParams = {}) {
    try {
      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce object
        window.dataLayer.push({
          event: eventName,
          ...eventParams
        });
      } else if (window.gtag) {
        window.gtag('event', eventName, eventParams);
      }
    } catch (error) {
      console.error('Error sending GA4 event:', error);
    }
  }

  _observeRatingsSummary() {

    const productModalContent = document.querySelector('#product-modal-content');
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const ratingsSummary = productModalContent.querySelector('.bv_ratings_summary');
          if (ratingsSummary) {
            observer.disconnect();
            this._handleRatingsSummary(ratingsSummary);
            break;
          }
        }
      }
    });

    observer.observe(productModalContent, { childList: true, subtree: true });
    this._ratingsObserver = observer;
  }

  _handleRatingsSummary(ratingsSummary) {
    ratingsSummary.addEventListener('mouseenter', () => {
      setTimeout(() => {
        const expandedButton = document.querySelector('.bv_button_component_container button[aria-expanded="true"]');
        if (expandedButton) {
          const productHandle = this.getAttribute('data-handle');
          expandedButton.addEventListener('click', () => this._redirectToCollections(productHandle));
        }
      }, 100);
    });
  }

  async getCollectionProducts(handle) {
    const query = `
      query getCollectionByHandle($handle: String!) {
        collection(handle: $handle) {
          products(first: 100) {
            edges {
              node {
                id
                title
                handle
                images(first: 1) { 
                  edges { 
                    node { 
                      src 
                    } 
                  } 
                }
                variants(first: 20) {
                  edges {
                    node {
                      sku
                      id
                      title
                      product {
                        title
                        handle
                      }
                      priceV2 {
                        amount
                        currencyCode
                      }
                      image { 
                        altText
                        src 
                        width
                      }
                      selectedOptions {
                        name
                        value
                      }
                      showForDoctorsRecommended:metafield(namespace: "custom", key: "show_for_doctor_s_recommended") {
                        value
                      }
                      retailPrice:metafield(namespace: "custom", key: "retail_price") {
                        value
                      }
                      showOTP:metafield(namespace: "custom", key: "show_otp_for_doctor_s_recommended") {
                        value
                      }
                      subscriptionSubText:metafield(namespace: "custom", key: "subscription_sub_text") {
                        value
                      }
                      sellingPlanAllocations(first: 1) {
                        nodes {
                          sellingPlan {
                            id
                            name
                            options {
                              name
                              value
                            }
                            priceAdjustments {
                              adjustmentValue {
                                ... on SellingPlanPercentagePriceAdjustment {
                                  __typename
                                  adjustmentPercentage
                                }
                              }
                            }
                          }
                          priceAdjustments {
                            price {
                              amount
                              currencyCode
                            }
                            compareAtPrice {
                              amount
                              currencyCode
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch(this.storefrontEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.storefrontToken
        },
        body: JSON.stringify({ query, variables: { handle } })
      });

      const json = await response.json();
      return json.data?.collection?.products?.edges.map(edge => ({
        ...edge.node,
        image: edge.node.images.edges.length > 0 ? edge.node.images.edges[0].node.src : '',
        variants: edge.node.variants.edges.map(variantEdge => variantEdge.node)
      })) || [];
    } catch (err) {
      console.error('Error fetching collection from Storefront API:', err);
      return [];
    }
  }
}

customElements.define('doctor-recommended', DoctorRecommended);

class RecommendedProduct extends DoctorRecommended {
  constructor() {
    super();
    this.initElements();
    this.addEventListeners();
    this.currentQuantity = 1;
    this.initialized = false;
    this.setupModalTriggers();
  }

  initElements() {
    this.subscription = this.querySelector('.recommended-card__subscription-container input');
    this.oneTime = this.querySelector('.recommended-card__one-time-container input');
    this.priceContainer = this.querySelector('.card__info-price');
    this.checkoutButton = document.querySelector('.checkout__btn');

    this.subscriptionPrice = this.subscription?.dataset.price || null;
    this.oneTimePrice = this.oneTime?.dataset.price || null;

    const parent = this.closest('doctor-recommended');
    if (parent) {
      this.cartData = parent.cartItems;
      this.matchedProducts = parent.matchedProducts || [];
      this.parent = parent;

      this.variant = this.matchedProducts
        .flatMap(product => product.variants)
        .find(variant => variant.id == this.id);

      if (this.variant) {
        this.variantId = this.variant.id.replace('gid://shopify/ProductVariant/', "");
      }
    }
    
    this.addQuantityControl();
  }

  initializeWithCartData(cartData) {
    if (this.initialized) return;
    
    if (!this.quantityInput) {
      this.addQuantityControl();
    }
    
    if (cartData && this.variantId) {
      const cartItem = cartData.find(item => item.id == this.variantId);
      if (cartItem) {
        this.currentQuantity = cartItem.quantity;
        if (this.quantityInput) {
          this.quantityInput.value = this.currentQuantity;
        }
      }
    }
    
    this.updateQuantityState();
    this.initialized = true;
  }

  async updateQuantity(change) {
    const newQuantity = Math.max(1, this.currentQuantity + change);
    if (newQuantity === this.currentQuantity) return;
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.variantId,
          quantity: newQuantity
        })
      });
      
      if (!response.ok) throw new Error('Failed to update cart');
      
      const cart = await response.json();
      this.currentQuantity = newQuantity;
      this.quantityInput.value = newQuantity;
      
      // Update minus button state based on new quantity
      this.minusButton.disabled = newQuantity <= 1;
      
      // Update all product cards with new cart data
      this.updateAllProductCards(cart.items);
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  }
  
  async removeItem() {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.variantId,
          quantity: 0
        })
      });
      
      if (!response.ok) throw new Error('Failed to update cart');
      
      const cart = await response.json();
      // Update all product cards with new cart data
      this.updateAllProductCards(cart.items);
      
      // Hide this product card if removed
      this.style.display = 'none';
    } catch (error) {
      console.error('Error removing item:', error);
    }
  }

  async addQuantityControl() {
    // Create quantity control container
    const quantityControlContainer = document.createElement('div');
    quantityControlContainer.className = 'recommended-card__quantity-control';
    
    // Create the quantity control HTML
    quantityControlContainer.innerHTML = `
      <div class="quantity-control__container">
        <div class="quantity-control__buttons">
          <button class="quantity-control__button quantity-control__button--minus" aria-label="Decrease quantity">−</button>
          <input type="number" class="quantity-control__input" value="1" min="1" readonly>
          <button class="quantity-control__button quantity-control__button--plus" aria-label="Increase quantity">+</button>
        </div>
        <button class="quantity-control__button quantity-control__button--remove" aria-label="Remove item">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g clip-path="url(#clip0_944_4122)">
              <path d="M10.5339 13.0592H3.4662C3.33362 13.0592 3.20235 13.0331 3.07987 12.9823C2.9574 12.9316 2.84612 12.8572 2.7524 12.7634C2.65869 12.6697 2.58436 12.5583 2.53368 12.4358C2.483 12.3133 2.45695 12.182 2.45703 12.0495V2.96289H11.543V12.0495C11.543 12.3171 11.4367 12.5738 11.2475 12.7631C11.0582 12.9523 10.8015 13.0592 10.5339 13.0592Z" stroke="#152C52" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.48633 10.0281V5.99023" stroke="#152C52" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.51367 10.0281V5.99023" stroke="#152C52" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M0.4375 2.96289H13.5625" stroke="#152C52" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.5144 0.943359H5.48573C5.35315 0.943359 5.22188 0.969482 5.0994 1.02023C4.97693 1.07099 4.86565 1.14537 4.77193 1.23914C4.67822 1.33292 4.60389 1.44423 4.55321 1.56674C4.50253 1.68924 4.47649 1.82053 4.47656 1.95311V2.96228H9.52415V1.95311C9.52415 1.68546 9.41782 1.42878 9.22857 1.23952C9.03931 1.05027 8.78205 0.943359 8.5144 0.943359Z" stroke="#152C52" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_944_4122">
                <rect width="14" height="14" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    `;
    
    // Get reference to the info container and append the quantity control
    const infoContainer = this.querySelector('.card__info__content');
    if (infoContainer) {
      infoContainer.appendChild(quantityControlContainer);
    }
    
    // Set up references to new elements
    this.minusButton = this.querySelector('.quantity-control__button--minus');
    this.plusButton = this.querySelector('.quantity-control__button--plus');
    this.removeButton = this.querySelector('.quantity-control__button--remove');
    this.quantityInput = this.querySelector('.quantity-control__input');
    
    // Add event listeners for quantity controls
    this.minusButton.addEventListener('click', () => this.updateQuantity(-1));
    this.plusButton.addEventListener('click', () => this.updateQuantity(1));
    this.removeButton.addEventListener('click', () => this.removeItem());
    

    const cart = await this.getCartItems();
    if (cart.length > 0) {
      const cartItem = cart.find(item => item.id == this.variantId);
      if (cartItem) {
        this.currentQuantity = cartItem.quantity;
        this.quantityInput.value = this.currentQuantity;
      }
    }
  }

  async updateQuantityState() {
    try {
      // Get current cart data
      const cart = await this.getCartItems();
      const cartItem = cart.find(item => item.id == this.variantId);
      
      if (!cartItem) return;
      
      if (!this.quantityInput || !this.minusButton || !this.removeButton) {
        return;
      }
      
      this.currentQuantity = cartItem.quantity;
      this.quantityInput.value = this.currentQuantity;
      
      // Check if this is the only item in the doctor's recommendation
      const recommendedItemsInCart = cart.filter(item => 
        this.parent?.cartItems?.some(recItem => recItem.id == item.id)
      );
      
      const totalRecommendedItems = recommendedItemsInCart.length;
      const totalRecommendedQuantity = recommendedItemsInCart.reduce((sum, item) => sum + item.quantity, 0);
      
      const isLastItem = totalRecommendedItems <= 1;
      const isLastUnitOfLastItem = isLastItem;
      
      // Disable minus button if quantity is 1
      if (this.minusButton) {
        this.minusButton.disabled = this.currentQuantity <= 1;
      }
      
      // Hide remove button if this is the last recommended item with quantity 1
      if (isLastUnitOfLastItem || totalRecommendedQuantity <= 1) {
        this.removeButton.style.display = 'none';
      } else {
        this.removeButton.style.display = 'block';
      }

      this.updateAllProductCards(cart);
    } catch (error) {
      console.error('Error updating quantity state:', error);
    }
  }

  updateAllProductCards(cart) {
    if (!this.parent) return;
    
    const allProductCards = this.parent.querySelectorAll('recommended-product');
    allProductCards.forEach(card => {
      if (card !== this && typeof card.updateQuantityState === 'function') {
        if (card.quantityInput && card.minusButton && card.removeButton) {
          card.updateQuantityStateWithCart(cart);
        }
      }
    });
  }

  updateQuantityStateWithCart(cart) {
    try {
      const cartItem = cart.find(item => item.id == this.variantId);
      
      if (!cartItem) return;
      
      this.currentQuantity = cartItem.quantity;
      this.quantityInput.value = this.currentQuantity;
      
      // Check if this is the only item in the doctor's recommendation
      const recommendedItemsInCart = cart.filter(item => 
        this.parent?.cartItems?.some(recItem => recItem.id == item.id)
      );
      
      const totalRecommendedItems = recommendedItemsInCart.length;
      const totalRecommendedQuantity = recommendedItemsInCart.reduce((sum, item) => sum + item.quantity, 0);
      
      const isLastItem = totalRecommendedItems <= 1;
      const isLastUnitOfLastItem = isLastItem;
      
      // Disable minus button if quantity is 1, enable otherwise
      if (this.minusButton) {
        this.minusButton.disabled = this.currentQuantity <= 1;
      }
      
      // Hide remove button if this is the last recommended item with quantity 1
      if (isLastUnitOfLastItem || totalRecommendedQuantity <= 1) {
        this.removeButton.style.display = 'none';
      } else {
        this.removeButton.style.display = 'block';
      }
    } catch (error) {
      console.error('Error updating quantity state with cart:', error);
    }
  }

  async connectedCallback() {
    if (this.variant && this.variantId) {
      const cart = await this.getCartItems();
      this.initializeWithCartData(cart);
    } else {
      setTimeout(async () => {
        if (this.variant && this.variantId) {
          const cart = await this.getCartItems();
          this.initializeWithCartData(cart);
        } else {
          console.warn('Variant or variantId not initialized for recommended product');
        }
      }, 500);
    }
  }
  
  addEventListeners() {
    if (this.subscription) {
      const subscription = this.variant?.sellingPlanAllocations?.nodes?.[0];
      const sellingPlanId = subscription?.sellingPlan?.id?.replace('gid://shopify/SellingPlan/', "")
      this.subscription.addEventListener('change', () => {
        this.updateSellingPlan(sellingPlanId);
      });
    }

    if (this.oneTime) {
      this.oneTime.addEventListener('change', () => {
        this.updateSellingPlan(null);
      });
    }
    
    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', async (e) => {
        e.preventDefault();
        window.location.href = "/checkout";
      });
    }
  }

  setupModalTriggers() {
    // Add event listeners after a short delay to ensure DOM is ready
    setTimeout(() => {
      const triggers = this.querySelectorAll('.product-modal-trigger');
      const productHandle = this.getAttribute('data-handle');
      
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const handle = trigger.getAttribute('data-handle') || productHandle;
          if (handle) {
            const parent = this.closest('doctor-recommended');
            if (parent) {
              parent.openProductModal(handle);
            }
          }
        });
        
        // Add pointer cursor to indicate clickable elements
        trigger.style.cursor = 'pointer';
      });
    }, 500);
  }

  updateSellingPlan(sellingPlanId) {
    if (!this.variantId) {
      console.error('Variant ID not found');
      return;
    }
    
    // Directly update cart with proper variant ID and selling plan
    this.updateCartSellingPlan(this.variantId, sellingPlanId);
  }

  async updateCartSellingPlan(itemId, sellingPlanId) {
    try {
      // First, get current cart to find line item ID 
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the line item in the cart matching our variant ID
      const lineItem = cart.items.find(item => item.id == itemId);
      
      if (!lineItem) {
        console.error('Item not found in cart');
        return;
      }
      
      const lineItemKey = lineItem.key;
      
      // Use line item key to update the selling plan
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: lineItem.quantity,
          selling_plan: sellingPlanId || null
        })
      });
  
      if (!response.ok) throw new Error('Failed to update cart');
  
      const result = await response.json();

      // Update the UI to reflect the current state
      const subscriptionOption = this.querySelector('.recommended-card__subscription-container input');
      const oneTimeOption = this.querySelector('.recommended-card__one-time-container input');
      
      if (subscriptionOption && oneTimeOption) {
        if (sellingPlanId) {
          subscriptionOption.checked = true;
          oneTimeOption.checked = false;
        } else {
          subscriptionOption.checked = false;
          oneTimeOption.checked = true;
        }
      }
      
    } catch (error) {
      console.error('Error updating cart selling plan:', error);
    }
  }
}

customElements.define('recommended-product', RecommendedProduct);